import {
  ackSchema,
  draftSchema,
  listDraftsResponseSchema,
  sendMessageResponseSchema,
  type Ack,
  type Draft,
  type DraftId,
  type SaveDraftRequest,
  type SendDraftRequest,
  type SendMessageResponse,
} from "@mailflare/shared";

import { apiRequest } from "@/lib/api-client";

export async function listDrafts(): Promise<readonly Draft[]> {
  return listDraftsResponseSchema.parse(await apiRequest<unknown>("/drafts")).drafts;
}

export async function getDraft(draftId: DraftId): Promise<Draft> {
  return draftSchema.parse(await apiRequest<unknown>(`/drafts/${encodeURIComponent(draftId)}`));
}

export async function createDraft(body: SaveDraftRequest): Promise<Draft> {
  return draftSchema.parse(await apiRequest<unknown>("/drafts", { method: "POST", body }));
}

export async function saveDraft(draftId: DraftId, body: SaveDraftRequest): Promise<Draft> {
  return draftSchema.parse(
    await apiRequest<unknown>(`/drafts/${encodeURIComponent(draftId)}`, { method: "PUT", body }),
  );
}

export async function deleteDraft(draftId: DraftId): Promise<Ack> {
  return ackSchema.parse(
    await apiRequest<unknown>(`/drafts/${encodeURIComponent(draftId)}`, { method: "DELETE" }),
  );
}

export async function sendDraft(
  draftId: DraftId,
  body: SendDraftRequest = {},
): Promise<SendMessageResponse> {
  return sendMessageResponseSchema.parse(
    await apiRequest<unknown>(`/drafts/${encodeURIComponent(draftId)}/send`, {
      method: "POST",
      body,
    }),
  );
}
